module.controller('mobileIdCtrl', ['$scope', 'ipCookie', '$http','baseURI', function($scope, ipCookie, $http, baseURI){

  var mobileIdUrl = baseURI + 'mobile-id';

  $scope.makeAuthorizeRequest = function() {
    $http.get(mobileIdUrl).then(function (resp){
      ipCookie('s_hash', resp.data.Data.SHash);
      window.open(resp.data.Data.RedirectUri);
    }).catch(function(err){
      console.log(err);
    });
  };
}]);


